<template>
  <div class="container-cpf-dia">
    <van-dialog v-model="showCpfDia" :showConfirmButton="false" closeOnClickOverlay="true" @close="close">
      <div class="dialog">
        <div class="title">
          {{ $t('lang.pay.cpfTip') }}
        </div>
        <div class="cpf-input">
          <span class="tit">CPF：</span>
          <input class="input" placeholder="000.000.000-00" v-model="formattedInputCPF" @input="formatInput" type="text" />
        </div>
        <div class="btn">
          <span @click="handleThinK" class="confirm-think">{{ $t('lang.think') }}</span>
          <span @click="handleConfirm" class="confirm-btn" :class="{ activeConfirmBtn: formattedInputCPF && formattedInputCPF.length >= 14 }">{{ $t('lang.confirm') }}</span>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  props: {
    showCpfDia: {
      default: false
    },
    methodData: {
      default: {}
    }
  },
  data() {
    return {
      formattedInputCPF: '',
      cpf: ''
    }
  },
  created() {},
  mounted() {},
  methods: {
    close() {
      this.$parent.showCpfDia = false
      this.formattedInputCPF = ''
    },
    handleThinK() {
      this.close()
    },
    handleConfirm() {
      this.$parent.handlePay(this.methodData, this.formattedInputCPF)
    },
    // cpf输入框
    formatInput(event) {
      const rawValue = event.target.value.replace(/\D/g, '') // 去除所有非数字字符
      let formatted = ''

      // 创建格式化字符串
      if (rawValue.length > 0) {
        formatted += rawValue.substring(0, 3) // 获取前三个字符
      }
      if (rawValue.length > 3) {
        formatted += '.' + rawValue.substring(3, 6) // 在第三个字符后添加点
      }
      if (rawValue.length > 6) {
        formatted += '.' + rawValue.substring(6, 9) // 在第六个字符后添加点
      }
      if (rawValue.length > 9) {
        formatted += '-' + rawValue.substring(9, 11) // 在第九个字符后添加短横线并获取最后两位
      }
      // 将格式化后的字符串更新到数据绑定
      this.formattedInputCPF = formatted
    }
  },

  watch: {
    'methodData.latestCpf': {
      handler(newVal, oldVal) {
        if (newVal) {
          this.cpf = newVal
        }
      },
      immediate: true,
      deep: true // 可以深度检测到 person 对象的属性值的变化
    },
    showCpfDia(newVal, oldVal) {
      if (newVal) {
        this.formattedInputCPF = this.cpf
      }
    }
  }
}
</script>

<style lang="less" scoped>
.container-cpf-dia {
  .dialog {
    width: 300px;
    background: #ffffff;
    border-radius: 12px;
    padding: 25px 20px 20px 20px;
    margin: 0 auto;

    .title {
      // width: 260px;
      // height: 40px;
      font-size: 16px;
      font-family: Inter-Medium, Inter;
      font-weight: 500;
      color: #333333;
      line-height: 20px;
      // text-align: center;
      margin: 10px 0;
    }
    .cpf-input {
      display: flex;
      align-items: center;
      margin-bottom: 18px;
      margin-bottom: 10px;
      // display: block;
      font-size: 17px;
      font-family: Inter-SemiBold;
      font-weight: 500;
      color: #333333;
      .tit {
        display: block;
        font-size: 16px;
        color: #000;
      }
      .input {
        width: 100%;
        height: 40px;
        padding: 0 10px;
        border-radius: 10px;
        border: 1px solid #ccc;
        &::placeholder {
          color: #b5b5b5 !important; /* 设置placeholder的文本颜色 */
          font-size: 14px !important; /* 设置placeholder的文本大小 */
        }
      }
    }
    .btn {
      display: flex;
      align-items: center;
      justify-content: space-around;
      > span {
        width: 120px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        margin: 10px auto 0;
        border-radius: 20px;
        font-size: 16px;
        font-family: Inter-SemiBold, Inter;
        font-weight: 600;
        color: #ffffff;
      }
      .confirm-think {
        background-color: #e1e1e1;
      }
      .confirm-btn {
        pointer-events: none;
        background-color: #999;
      }
      .activeConfirmBtn {
        pointer-events: auto;
        background: #a338fc;
      }
    }
  }
}
</style>
